module.exports = __webpack_public_path__ + "static/media/kaple.64f1f8f0.jpg";